import { useEffect, useState } from "react"
import { useCustomQuery } from "./useCustomQuery"

const useAttributes = () => {
  const [attributes, setAttributes] = useState([])
  const {
    data: attributeResponse,
    isLoading,
    isError,
    isFetching,
  } = useCustomQuery(["attribute-all"], "attribute/all")

  useEffect(() => {
    if (attributeResponse?.data) {
      setAttributes(attributeResponse.data)
    }
  }, [attributeResponse])
  return {
    attributes,
    isLoading,
    isError,
    isFetching,
    setAttributes,
  }
}

export default useAttributes
